import { render } from "./CustomChart.vue?vue&type=template&id=46e617fe&scoped=true"
import script from "./CustomChart.vue?vue&type=script&lang=js"
export * from "./CustomChart.vue?vue&type=script&lang=js"

import "./CustomChart.vue?vue&type=style&index=0&id=46e617fe&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e617fe"]])

export default __exports__